module.exports = __webpack_public_path__ + "static/img/cabinet24_20.a51dc3c6.gif";